import { ACTIONS, SUB_PAGE } from '../../constants';

const initSubPage = () => {
  let subPage = '';
  // check  + replace hash
  if (window.location.hash.indexOf('pamatnik') !== -1) {
    subPage = SUB_PAGE.MEMORIAL;
    window.history.pushState('', document.title, window.location.pathname);
  }
  return subPage;
};

const initState = {
  autoplay: true,
  hoveredSpot: -1, // -1 = none, 0-12
  lastOpenSpot: -1, // to hilite last clicked timeline section
  hiliteId: '', // to hilite bullets on hover
  subSection: '', // for - intro + outro
  subPage: initSubPage(), // for - info + memorial
  sceneVideo: '', // video id
  sceneVideoPosition: 1, // 1/-1 - top/bottom
  compactVideo: '',
  completeVideos: [],
  soundBlockState: false,
};

const app = (state = initState, action) => {
  switch (action.type) {
    case ACTIONS.SET_SUBPAGE:
      return {
        ...state,
        subPage: action.pageId,
      };
    case ACTIONS.SOUND_BLOCKED:
      return {
        ...state,
        soundBlockState: action.soundBlockState,
      };
    case ACTIONS.SET_SUB_SECTION:
      return {
        ...state,
        subSection: action.sectionId,
        lastOpenSpot:
          action.sectionId.length > 0 ? state.hoveredSpot : state.lastOpenSpot,
        sceneVideo: '',
      };
    case ACTIONS.SET_SCENE_VIDEO:
      return {
        ...state,
        subSection: '',
        sceneVideo: action.videoId,
        lastOpenSpot:
          action.videoId.length > 0 ? state.hoveredSpot : state.lastOpenSpot,
        sceneVideoPosition: action.position,
      };
    case ACTIONS.SET_HOVERED_SPOT:
      return {
        ...state,
        hoveredSpot: action.spotId,
      };
    case ACTIONS.SET_HILITE_ID:
      return {
        ...state,
        hiliteId: action.hiliteId,
      };
    case ACTIONS.SET_COMPACT_VIDEO:
      return {
        ...state,
        compactVideo: action.videoId,
      };
    case ACTIONS.VIDEO_COMPLETE:
      return {
        ...state,
        completeVideos:
          state.completeVideos.indexOf(action.videoId) === -1
            ? [...state.completeVideos, action.videoId]
            : state.completeVideos,
      };
    default:
      return state;
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/redux/reducers/app.js